<div class="line-chart">
  <div class="chart-period">
    <mat-radio-group [(ngModel)]="selectedPeriod" class="chart-period--group">
      <mat-radio-button
        *ngFor="let period of graphPeriods"
        [value]="period"
        class="chart-period--button"
        [checked]="period === selectedPeriod"
        (change)="handeSelectedPeriodChanged($event)"
      >
        {{ period }}
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="chart-wrap">
    <div class="chart-container">
      <canvas
        baseChart
        [legend]="true"
        [chartType]="chartType"
        [options]="chartOptions"
        [labels]="sumOfJobsChartLabels"
        [colors]="sumOfJobsChartColors"
        [datasets]="sumOfJobsChartDataSets"
      >
      </canvas>
    </div>
    <div class="chart-container">
      <canvas
        baseChart
        [legend]="true"
        [chartType]="chartType"
        [options]="chartOptions"
        [colors]="totalCutCreaseChartColors"
        [labels]="totalCutCreaseChartLabels"
        [datasets]="totalCutCreaseChartDataSets"
      >
      </canvas>
    </div>
  </div>
</div>
